// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2qqQ2","footer":"ModalCreateQualiphyProcedure_footer__3te3Y","additionData":"ModalCreateQualiphyProcedure_additionData__2c8hd"};